import type React from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { DefaultLayout } from "~/components/Layout";
import { ModalContent, useModal } from "~/components/Modal";

export const OidcError: React.FC = () => {
	const [openModal] = useModal();

	const [searchParams] = useSearchParams();
	const description = searchParams.get("error_description");

	useEffect(() => {
		openModal({
			type: "error",
			title: "ERROR",
			children: (
				<>
					<ModalContent>
						<div className="text-center">
							{description ?? "Unexpected errors occurred"}
						</div>
					</ModalContent>
				</>
			),
		});
	}, [description, openModal]);

	return (
		<>
			<title>Error | TIER IV Account</title>
			<DefaultLayout>
				<main className="main-section flex flex-col justify-center items-center" />
			</DefaultLayout>
		</>
	);
};
